'use strict';
const createSVGDOM = require('./create-svg-dom'),
	getTextElement = function (parentElement, labelText, elementType, centrePoint) {
		elementType = elementType || 'text';
		const textElement = parentElement.querySelector(elementType + '.mapjs-connector-text');
		if (!labelText) {
			if (textElement) {
				textElement.remove();
			}
			return false;
		} else if (textElement) {
			return textElement;
		} else {
			const textElementDOM = createSVGDOM(elementType);
			textElementDOM.setAttribute('class', 'mapjs-connector-text');

			if (centrePoint) {
				textElementDOM.style.transform = `translate(${centrePoint.x}px, ${centrePoint.y}px)`;
			}
			parentElement.appendChild(textElementDOM);
			return textElementDOM;
		}
	};
module.exports = function updateConnectorText(stage, parentElement, centrePoint, labelText, labelTheme) {
	const g = getTextElement(parentElement, labelText, 'g', centrePoint),
		rectDOM = g && getTextElement(g, labelText, 'rect'),
		textDOM = g && getTextElement(g, labelText),
		translate = {},
		getUnscaledDimensions = () => {
			const dimensions = textDOM.getClientRects()[0],
				scale = stage.getStageData().scale || 1;
			if (!dimensions) /* element was removed */ {
				return {height: 0, width: 0};
			}
			return {
				height: dimensions.height / scale,
				width: dimensions.width / scale
			};
		};

	let dimensions = false;
	if (!textDOM) {
		return false;
	}
	textDOM.style.stroke = 'none';
	textDOM.style.fill = labelTheme.text.color;
	textDOM.style.fontSize = labelTheme.text.font.sizePx + 'px';
	textDOM.style.fontWeight = labelTheme.text.font.weight;
	textDOM.style.dominantBaseline = 'hanging';
	textDOM.textContent = labelText.trim();
	dimensions = getUnscaledDimensions();
	translate.x = Math.round(centrePoint.x - dimensions.width / 2);
	translate.y = Math.round(centrePoint.y - dimensions.height - 2);
	g.style.transform = `translate(${translate.x}px, ${translate.y}px)`;
	textDOM.setAttribute('x', 0); //Math.round(centrePoint.x - dimensions.width / 2));
	textDOM.setAttribute('y', 2); //Math.round(centrePoint.y - dimensions.height));
	rectDOM.setAttribute('x', 0); //Math.round(centrePoint.x - dimensions.width / 2));
	rectDOM.setAttribute('y', 0); //Math.round(centrePoint.y - dimensions.height - 2));
	rectDOM.setAttribute('height', Math.round(dimensions.height));
	rectDOM.setAttribute('width', Math.round(dimensions.width));
	rectDOM.style.fill = labelTheme.backgroundColor;
	rectDOM.style.stroke = labelTheme.borderColor;
};

